import { Button } from "@material-ui/core";
import {arr as dashMaps} from "./userRole";
import { useUser } from "../../providers/user"
import { Redirect } from "react-router-dom";

export const NewDash = () => {
    const {profile, loading, logout} = useUser();
    const dash = dashMaps.filter((item) => item.role === profile?.usergroup);
    if(loading){
        return <div>Logging in...</div>
    }else if (dash.length === 1){
        return <Redirect to={`/dashboard/${dash[0].url}`} />;
    }else if(dash.length>1){
        return (
            <div>
                <h1>Go to dashboard</h1>
                {dash.map((item) => (
                    <Button key={item.url} href={`/dashboard/${item.url}`}>{item.name}</Button>
                ))}
                <Button onClick={logout}>Logout</Button>
            </div>
        )
    }
    return (
        <div>
            <h1>You are not authorized to view this page</h1>
            <Button variant="contained" onClick={logout}>Logout</Button>
        </div>
    )
}